import { TabList, TabListProps } from '@mui/lab';
import { cn } from '@nexelem/utils';

const indicatorHeight: Record<string, number> = {
  medium: 2,
  large: 4,
  jumbo: 4,
};

type StyledTabListProps = TabListProps & {
  size?: 'medium' | 'large' | 'jumbo';
};

export const DetailsTabList = ({ className, size = 'medium', sx, ...props }: StyledTabListProps) => (
  <TabList
    {...props}
    className={cn('min-h-11 shrink-0 border-b border-border-primary', className)}
    sx={{
      ...sx,
      '.MuiTabs-indicator': {
        backgroundColor: 'var(--color-border-brand-darker)',
        height: indicatorHeight[size],
      },
      '&:has(.hasError.Mui-selected) .MuiTabs-indicator': {
        backgroundColor: 'var(--color-border-status-red-dark)',
      },
    }}
  />
);
